/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import Toggle from "react-toggle";
import SvgIcon from "./SvgIcon";

export type ToggleIcons = {
  checked?: React.ReactNode;
  unchecked?: React.ReactNode;
};

export type ToggleProps = React.ComponentPropsWithRef<"input"> & {
  "aria-labelledby": string | undefined;
  "aria-label": string | undefined;
  icons: boolean | ToggleIcons | undefined;
};

export type SwitchProps = ToggleProps & {
  label?: string;
  info?: string;
  errorMessage?: string;
};

const Switch = React.forwardRef((props: SwitchProps, ref) => {
  const { label, info, errorMessage, ...rest } = props;
  const invalid = !!errorMessage;

  return (
    <div className={`mb-3 ${invalid && "field-group--invalid"}`}>
      {label && <label className="label">{label}</label>}
      {info && (
        <span
          className="help"
          data-bs-toggle="tooltip"
          data-trigger="hover"
          data-placement="right"
          data-html="true"
          data-container="body"
          title={info}
        >
          <SvgIcon name="question-circle" className="ml-1 label" />
        </span>
      )}
      <div>
        <Toggle ref={ref} icons={false} {...rest} />
      </div>
      {invalid && (
        <div className="field-helper">
          <label>{errorMessage}</label>
        </div>
      )}
    </div>
  );
});

Switch.displayName = "Switch";

export default Switch;
